import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable no-underscore-dangle */
import React, { PureComponent, Component } from 'react';
import PropTypes from 'prop-types';
import toPlainObject from 'lodash/toPlainObject';
import signal from './signal';
import createTranslator from './createTranslator';

export var TranslatorProvider = function (_PureComponent) {
  _inherits(TranslatorProvider, _PureComponent);

  function TranslatorProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TranslatorProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TranslatorProvider.__proto__ || _Object$getPrototypeOf(TranslatorProvider)).call.apply(_ref, [this].concat(args))), _this), _this._signal = signal(), _this._createT = function (translations) {
      _this._t = createTranslator(toPlainObject(translations));
      _this._t.getValue = function () {
        return _this._t;
      };
      _this._t.subscribe = _this._signal.subscribe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TranslatorProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        t: this._t
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._createT(this.props.translations);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(_ref2) {
      var translations = _ref2.translations;

      this._createT(translations);
      this._signal.dispatch(this._t);
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);

  return TranslatorProvider;
}(PureComponent);

TranslatorProvider.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  translations: PropTypes.object,
  children: PropTypes.node
};
TranslatorProvider.childContextTypes = {
  t: PropTypes.func.isRequired
};
TranslatorProvider.defaultProps = {
  translations: {}
};
var LackOfTErrorMessage = 'Unable to access t function. Ensure that <TranslatorProvider> is in place' + ' provided with translations object.';
var tFallback = function tFallback() {
  for (var _len2 = arguments.length, contextArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    contextArgs[_key2] = arguments[_key2];
  }

  return function (key) {
    return contextArgs.join('.') + ':' + key;
  };
};

var validateAndProvideT = function validateAndProvideT(WrappedComponent) {
  var _class, _temp3;

  return (
    // eslint-disable-next-line react/no-multi-comp
    _temp3 = _class = function (_Component) {
      _inherits(TConsumer, _Component);

      function TConsumer() {
        var _ref3;

        var _temp2, _this2, _ret2;

        _classCallCheck(this, TConsumer);

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref3 = TConsumer.__proto__ || _Object$getPrototypeOf(TConsumer)).call.apply(_ref3, [this].concat(args))), _this2), _this2._t = tFallback, _this2._substituteT = function (t) {
          _this2._t = t;
          _this2.forceUpdate();
        }, _this2._unsubscribe = function () {}, _temp2), _possibleConstructorReturn(_this2, _ret2);
      }

      _createClass(TConsumer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          var t = this.context.t;

          if (!t) {
            console.error(LackOfTErrorMessage);
            return;
          }

          this._t = Object.hasOwnProperty.call(t, 'getValue') ? t.getValue() : t;
          if (this._t.subscribe) {
            this._unsubscribe = this._t.subscribe(this._substituteT);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this._unsubscribe();
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(WrappedComponent, _extends({}, this.props, {
            t: this._t
          }));
        }
      }]);

      return TConsumer;
    }(Component), _class.displayName = 'withTranslator(' + (WrappedComponent.displayName || WrappedComponent.name) + ')', _class.contextTypes = {
      t: PropTypes.func.isRequired
    }, _temp3
  );
};

export var withTranslator = function withTranslator(wrappedComponent) {
  return validateAndProvideT(wrappedComponent);
};